import { useEffect, useRef } from 'react';
import { useStore } from 'reactflow';

const connectionNodeIdSelector = (state: { connectionNodeId: any }) =>
	state.connectionNodeId;

// enables mouse events on the handle only if connecting an edge to it
export default (id: string) => {
	const handleRef = useRef<HTMLDivElement>();

	const connectionNodeId = useStore(connectionNodeIdSelector);
	const isTarget = connectionNodeId && connectionNodeId !== id;

	useEffect(() => {
		const handleEle = handleRef.current;
		if (handleEle) {
			handleEle.style.zIndex = isTarget ? '1' : '-1';
		}
	}, [isTarget, handleRef]);

	return [handleRef];
};
